import type { ChatModelAdapter, ThreadMessage } from '@assistant-ui/react'

export const mockRagAdapter: ChatModelAdapter = {
	async *run({ messages, abortSignal }) {
		const serverMessages = messages
			.filter((m: ThreadMessage) => m.role === 'user' || m.role === 'assistant')
			.map((m: ThreadMessage) => ({
				role: m.role,
				content: (m.content ?? []).filter((p: any) => p.type === 'text').map((p: any) => ({ text: p.text })),
			}))

		const response = await fetch('/api/chat', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ messages: serverMessages, id: crypto.randomUUID() }),
			signal: abortSignal,
		})

		if (!response.ok || !response.body) {
			throw new Error(`Chat API error: ${response.status}`)
		}

		const reader = response.body.getReader()
		const decoder = new TextDecoder()
		let accumulatedText = ''
		let buffer = ''

		while (true) {
			const { done, value } = await reader.read()
			if (done) break

			buffer += decoder.decode(value, { stream: true })
			const lines = buffer.split('\n')
			buffer = lines.pop() || ''

			for (const line of lines) {
				if (!line.startsWith('data: ')) continue
				const data = line.slice(6)
				if (data === '[DONE]') continue

				try {
					const event = JSON.parse(data)
					if (event.type === 'TEXT_MESSAGE_CONTENT' && event.delta) {
						accumulatedText += event.delta
						yield {
							content: [{ type: 'text' as const, text: accumulatedText }],
						}
					}
				} catch {
					// skip unparseable events
				}
			}
		}

		if (accumulatedText) {
			yield {
				content: [{ type: 'text' as const, text: accumulatedText }],
			}
		}
	},
}
